<template>
  <div class="container">
    <div class="card">
      <div class="card-header">
        <div class="card-title">
          <fai icon="user"/>&nbsp;Registrar Parámetro
        </div>
      </div>
      <div class="card-body pb-5">
        <!--begin: Details -->
        <div class="row mt-4">
          <div class="col-sm-6">
            <h4 class="font-info">Datos Generales</h4>
          </div>
        </div>
        <sys-form :inputs="config_details"/>
        <!--end: Details -->
        <hr class="mt-4"/>
      </div>
      <div class="card-footer text-right">
        <button class="btn btn-secondary" @click="$router.push({ name: 'configs' })">
          <fai icon="reply"/> Cancelar
        </button>
        <button class="btn btn-success" :class="{ 'disabled': form.isSaving }" @click="saveForm">
          <fai :icon="['far','edit']"/> Guardar
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import configsService from '@/services/configs'
import SysForm from '@/components/shared/Form'
import formMixin from '@/mixins/form'

export default {
  name: 'ConfigCreate',

  components: { SysForm },

  mixins: [ formMixin ],

  data () {
    return {
      config_details: {
        name: {
          name: 'Nombre',
          value: '',
          type: 'text'
        },
        value: {
          name: 'Valor',
          hint: 'Valor',
          value: '',
          type: 'text'
        },
        type: {
          name: 'Tipo',
          hint: 'Tipo',
          value: '',
          type: 'text'
        },
        description: {
          name: 'Descripción',
          hint: 'Descripción',
          value: '',
          type: 'textarea'
        }
      }
    }
  },
  methods: {
    saveForm: function () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          let accountInfo = { ...this.config_details }

          console.log(accountInfo)

          let body = this.processForm(accountInfo)
          let service = configsService.post(body)

          this.sendForm(service).then(res => {
            this.$router.push({ name: 'configs' })
          }).catch(err => {
            console.log(JSON.stringify(err))
          })
        }
      })
    }
  },
  watch: {
  }
}
</script>



// WEBPACK FOOTER //
// src/components/configs/ConfigCreate.vue